function getEvidenceItemLabel(item: unknown): string {
  if (item == null || item === '') return '';
  if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
  if (typeof item === 'object' && item !== null && 'name' in item) {
    const name = (item as { name?: unknown }).name;
    if (typeof name === 'string' || typeof name === 'number') return String(name).trim();
  }
  return '';
}

/** Formats evidence list fields such as disease_model ({id, name}[]) and sex (string[]). */
export function formatEvidenceNamedList(value: unknown): string {
  if (value == null || value === '') return '-';

  if (Array.isArray(value)) {
    if (value.length === 0) return '-';
    const labels = value.map(getEvidenceItemLabel).filter(Boolean);
    return labels.length > 0 ? labels.join(', ') : '-';
  }

  const label = getEvidenceItemLabel(value);
  return label || '-';
}
